import { ChangeDetectionStrategy, Component, Input, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/AuthService';

interface FooterLinkVm {
  label: string;
  routerLink: string;
  fragment?: string;
}

const COMPANY_LINKS: ReadonlyArray<FooterLinkVm> = [
  { label: 'About PeerLiv', routerLink: '/about' },
  { label: 'Our Mission', routerLink: '/landing', fragment: 'our-mission' },
  { label: 'Community Guidelines', routerLink: '/community-guidelines' },
  { label: 'Contact Us', routerLink: '/contact' },
];

const LEGAL_LINKS: ReadonlyArray<FooterLinkVm> = [
  { label: 'Privacy Policy', routerLink: '/privacy' },
  { label: 'Terms of Service', routerLink: '/terms' },
  { label: 'Cookie Policy', routerLink: '/cookie-policy' },
  { label: 'Medical Disclaimer', routerLink: '/medical-disclaimer' },
];

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './app-footer.html',
  styleUrls: ['./app-footer.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppFooterComponent {
  private readonly authService = inject(AuthService);

  @Input() withBottomNav = false;

  readonly companyLinks = COMPANY_LINKS;
  readonly legalLinks = LEGAL_LINKS;
  readonly currentYear = new Date().getFullYear();

  readonly isPublicFooter = computed(
    () => this.authService.authReady() && !this.authService.isAuthenticated()
  );
}
